import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartPie = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4375 2.05892C8.4375 1.97192 8.3625 1.90292 8.2755 1.91192C6.52038 2.09132 4.89423 2.91551 3.71185 4.22494C2.52947 5.53437 1.87496 7.23591 1.875 9.00017C1.87499 10.4117 2.29422 11.7914 3.07952 12.9643C3.86482 14.1371 4.98079 15.0503 6.28587 15.588C7.59095 16.1257 9.02633 16.2636 10.4099 15.9843C11.7935 15.705 13.063 15.021 14.0573 14.0192C14.0718 14.0045 14.083 13.9868 14.0903 13.9675C14.0976 13.9481 14.1008 13.9275 14.0996 13.9068C14.0984 13.8862 14.0928 13.866 14.0833 13.8477C14.0739 13.8293 14.0606 13.8131 14.0445 13.8002L8.64675 9.43742C8.58148 9.38475 8.52881 9.31815 8.49261 9.24249C8.4564 9.16684 8.43757 9.08404 8.4375 9.00017V2.05892Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7525 12.9253C14.82 12.9801 14.9205 12.9658 14.9685 12.8923C15.5908 11.9413 15.9751 10.8544 16.089 9.7236C16.0909 9.70309 16.0885 9.68241 16.0819 9.6629C16.0753 9.64339 16.0647 9.62546 16.0508 9.61028C16.0369 9.5951 16.02 9.58299 16.0011 9.57473C15.9822 9.56648 15.9618 9.56226 15.9413 9.56235H11.0153C10.9843 9.56241 10.9542 9.57203 10.9289 9.5899C10.9036 9.60777 10.8845 9.63302 10.8742 9.66217C10.8638 9.69133 10.8628 9.72297 10.8711 9.75276C10.8794 9.78256 10.8968 9.80904 10.9208 9.82859L14.7525 12.9253ZM15.9413 8.43735C16.0283 8.43735 16.0973 8.36235 16.089 8.27535C15.9221 6.6443 15.1979 5.12068 14.0385 3.96133C12.8792 2.80197 11.3556 2.07779 9.7245 1.91085C9.70394 1.90885 9.68318 1.91119 9.66358 1.91772C9.64397 1.92425 9.62595 1.93482 9.61069 1.94874C9.59542 1.96266 9.58324 1.97964 9.57494 1.99856C9.56664 2.01748 9.56241 2.03793 9.5625 2.0586V8.21235C9.5625 8.27202 9.58621 8.32925 9.6284 8.37144C9.6706 8.41364 9.72783 8.43735 9.7875 8.43735H15.9413Z",
			fill: "current"
		})
	]
});
const ForwardRef = forwardRef(SvgChartPie);
export { ForwardRef as ReactComponent };
